import { inject } from '@angular/core';
import { patchState, signalStore, withHooks, withMethods, withState } from '@ngrx/signals';
import { setAllEntities, withEntities } from '@ngrx/signals/entities';
import dayjs from 'dayjs';
import { Activity } from '../components/organisms/activities/activities.types';
import { ToastTypeEnum } from '../components/organisms/toast/toast.type';
import { RequestStateEnum } from '../enums/app.enum';
import { ActivityService } from '../services/activity.service';
import { ToastService } from '../services/toast.service';

interface TodaysActivityState {
  requestState: RequestStateEnum | null;
}

const initialState: TodaysActivityState = { requestState: null };

export const TodaysActivityStore = signalStore(
  { providedIn: 'root' },
  withState(initialState),
  withEntities<Activity>(),
  withMethods((store) => {
    const activityService = inject(ActivityService);
    const toastService = inject(ToastService);

    return {
      async load() {
        patchState(store, { requestState: RequestStateEnum.PENDING });

        activityService.fetchActivitiesInRange(dayjs(), dayjs(), 20, 0).subscribe({
          next: (response) => {
            patchState(store, { requestState: RequestStateEnum.SUCCESS });
            patchState(store, setAllEntities(response.payload));
          },
          error: () => {
            patchState(store, { requestState: RequestStateEnum.ERROR });
            toastService.addToast('Aktivitäten konnten nicht geladen werden', ToastTypeEnum.ERROR);
          },
        });
      },
    };
  }),
  withHooks({
    onInit(store) {
      store.load();
    },
  })
);
